<!--
 * @Author: Pluto 66291979@qq.com
 * @Date: 2024-05-22 14:18:31
 * @LastEditors: guojia 66291979@qq.com
 * @LastEditTime: 2024-08-28 20:01:02
 * @FilePath: /lobby/src/components/CountrySelectMenu.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div>
    <div class="btn" @click="onShowSelectCountry">
      <img :src="countries[country].icon" style="height: 0.4rem" />&nbsp;+{{
        countries[country].phone
      }}
      <i class="bi-caret-down-fill"></i>
    </div>
  </div>
</template>

<script>
import { useUserStore } from '@/stores/user'
import { BUS, POPUP } from '@/event/EventCenter'
import { mapState } from 'pinia'

export default {
  name: 'DhCountrySelectMenu',
  props: {
    from: {
      type: String,
      default: 'register'
    }
  },
  data() {
    return {
      app_env: import.meta.env.VITE_APP_ENV
    }
  },
  computed: {
    ...mapState(useUserStore, ['country', 'countries'])
  },
  mounted() {},

  methods: {
    onShowSelectCountry() {
      this.$bus.$emit(BUS.SHOW_POPUP, {
        from: this.from,
        to: POPUP.SELECT_COUNTRY,
        show: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Droid Sans;
  font-weight: 400;
  font-size: 0.24rem;
  color: #000000;
  line-height: 0.22rem;

  i {
    color: black;
  }
}
</style>
